import React from 'react';

const FALLBACK_TAILWIND = {
    pending: 'bg-yellow-100 text-yellow-800',
    assigned: 'bg-blue-100 text-blue-800',
    driver_started: 'bg-purple-100 text-purple-800',
    vendor_reached_location: 'bg-indigo-100 text-indigo-800',
    service_in_progress: 'bg-orange-100 text-orange-800',
    service_complete: 'bg-green-100 text-green-800',
    service_resolved: 'bg-green-100 text-green-800',
    service_cancelled: 'bg-red-100 text-red-800',
    vendor_not_accepted: 'bg-red-100 text-red-800',
    awaiting_customer_payment: 'bg-amber-100 text-amber-800',
    scheduled: 'bg-slate-100 text-slate-800',
    vendor_scheduled: 'bg-slate-100 text-slate-800',
};

function hexToRgba(hex, alpha = 0.15) {
    if (!hex || typeof hex !== 'string') return null;
    const normalized = hex.replace('#', '').trim();
    if (normalized.length !== 6) return null;
    const r = parseInt(normalized.slice(0, 2), 16);
    const g = parseInt(normalized.slice(2, 4), 16);
    const b = parseInt(normalized.slice(4, 6), 16);
    if ([r, g, b].some((n) => Number.isNaN(n))) return null;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function getStatusCatalogEntry(status, catalog = []) {
    if (!status) return null;
    return catalog.find((row) => row.code === status) || null;
}

export function getStatusLabel(status, catalog = []) {
    const entry = getStatusCatalogEntry(status, catalog);
    if (entry?.label) return entry.label;
    return String(status || '')
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase();
}

export function getStatusMarkerColor(status, catalog = []) {
    const entry = getStatusCatalogEntry(status, catalog);
    if (entry?.color) return entry.color;
    const fallback = {
        pending: '#F59E0B',
        assigned: '#3B82F6',
        driver_started: '#8B5CF6',
        vendor_reached_location: '#6366F1',
        service_in_progress: '#F97316',
        service_complete: '#10B981',
        service_resolved: '#10B981',
        vendor_not_accepted: '#EF4444',
        awaiting_customer_payment: '#D97706',
    };
    return fallback[status] || '#64748B';
}

const ServiceStatusBadge = ({
    status,
    catalog = [],
    className = '',
    showLabel = true,
    escalated = false,
    compact = false,
}) => {
    const entry = getStatusCatalogEntry(status, catalog);
    const label = showLabel ? getStatusLabel(status, catalog) : '';
    const color = entry?.color;
    const bg = color ? hexToRgba(color, 0.18) : null;

    const style =
        color && bg
            ? {
                  backgroundColor: bg,
                  color,
                  border: `1px solid ${hexToRgba(color, 0.35)}`,
              }
            : undefined;

    const tailwind = !style ? FALLBACK_TAILWIND[status] || 'bg-gray-100 text-gray-800' : '';

    const badgeClass = compact
        ? 'px-2 py-0.5 inline-flex text-[11px] leading-4 font-semibold rounded-full whitespace-nowrap max-w-[140px] truncate'
        : 'px-2 py-1 inline-block text-xs leading-5 font-semibold rounded-md text-center capitalize';

    return (
        <div className={`inline-flex flex-col gap-0.5 ${className}`}>
            <span className={`${badgeClass} ${tailwind}`} style={style} title={label}>
                {label}
            </span>
            {escalated ? (
                <span className="px-1.5 py-0.5 text-[10px] font-semibold rounded-full bg-red-100 text-red-800 whitespace-nowrap">
                    OTP Escalated
                </span>
            ) : null}
        </div>
    );
};

export default ServiceStatusBadge;
